// Capture only this provider's callback, before analytics and Auth0 initialize.
// Keep the authorization code in memory, never in storage or telemetry URLs.
const params =
  typeof window !== 'undefined' && window.location.pathname === '/instagram/callback'
    ? new URLSearchParams(window.location.search)
    : null;
export const instagramCallback = params
  ? {
      code: params.get('code'),
      state: params.get('state'),
      error: params.get('error')
    }
  : null;
if (params) window.history.replaceState(window.history.state, '', '/instagram/callback');
